module.exports = __webpack_public_path__ + "img/art-test-icon1.39c4a589.png";